<template>
  <div style="text-align: left">
    <div>
      <TopBar :msg="titName" :pageNum="backNum"></TopBar>
    </div>
    <van-cell-group>
      <van-cell title="出库单号" :value="topShowData.cSalesNo" />
      <van-cell title="客户名称" :value="topShowData.cInCustomerName" />
      <van-cell title="客户手机" :value="topShowData.cInCustomerMobile" />
      <van-cell title="出库数量" :value="topShowData.fTotalCompleteCount" />
      <van-cell
        title="出库时间"
        :value="topShowData.tCreateDate.replace(/T/, ' ').split('.')[0]"
      />
    </van-cell-group>
    <van-empty description="" v-if="list.length == 0" />
    <div class="scanList" v-for="item in list" :key="item.cSalesNo">
      <div class="listBottom">
        <div class="listBottomLine">
          <p>产品名称：</p>
          <p>{{ item.cProductName }}</p>
        </div>
        <div class="listBottomLine">
          <p>产品规格：</p>
          <p>{{ item.cStandard }}</p>
        </div>
        <div class="listBottomLine">
          <p>出库数量：</p>
          <p>{{ item.fCompleteCount }}</p>
        </div>
        <div class="listBottomLine">
          <div @click="showCodeDetail(item.id)">查看码详情</div>
        </div>
      </div>
    </div>
    <van-popup v-model="show" position="bottom" :style="{ height: '50%' }">
      <van-cell-group>
        <van-cell title="产品名称" :value="maskData.cProductName" />
        <van-cell title="产品规格" :value="maskData.cStandard" />
        <van-cell title="出库数量" :value="maskData.fCompleteCount" />
      </van-cell-group>
      <van-divider>码列表</van-divider>
      <div class="detailList" v-for="item in detailBigList" :key="item.id">
        <p>防伪码：{{ item.fBigCode }}</p>
        <p>类型：大码</p>
      </div>
      <div class="detailList" v-for="item in detailSmallList" :key="item.id">
        <p>{{ item.fSmallCode }}</p>
        <p>类型：小码</p>
      </div>
    </van-popup>
  </div>
</template>

<script>
// @ is an alias to /src
import {
  Button,
  List,
  Cell,
  Toast,
  Empty,
  Popup,
  Divider,
  CellGroup,
} from "vant";
import TopBar from "../../components/TopBar";

export default {
  data() {
    return {
      titName: "出库日志详情",
      backNum: -1,
      list: [],
      loading: false,
      finished: false,
      num: 1,
      show: false,
      topShowData: "",
      detailBigList: [],
      detailSmallList: [],
      maskData: {
        cProductName: "",
        cStandard: "",
        fCompleteCount: "",
      },
    };
  },
  components: {
    [Button.name]: Button,
    [List.name]: List,
    [Cell.name]: Cell,
    [Toast.name]: Toast,
    [Empty.name]: Empty,
    [Popup.name]: Popup,
    [Divider.name]: Divider,
    [CellGroup.name]: CellGroup,
    TopBar: TopBar,
  },
  methods: {
    showCodeDetail(id) {
      var _this = this;
      var dd = {
        fDealerSalesBodyId: id,
        ticket: sessionStorage.getItem("ticket"),
      };
      this.$get("/api/PhoneAPI/GetDealerSalesBodyDetail", dd)
        .then((res) => {
          if (res.IsSucceed) {
            _this.detailBigList = res.Content.BigCodeList;
            _this.detailSmallList = res.Content.SmallCodeList;
            _this.maskData.cProductName = res.Content.cProductName;
            _this.maskData.cStandard = res.Content.cStandard;
            _this.maskData.fCompleteCount = res.Content.fCompleteCount;
            _this.show = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  created: function () {
    var _this = this;
    this.topShowData = JSON.parse(this.$route.query.data);
    var dd = {
      fDealerSalesHeaderId: this.$route.query.id,
      ticket: sessionStorage.getItem("ticket"),
      page: 1,
      limit: 10000,
    };
    this.$get("/api/PhoneAPI/GetDealerSalesBody", dd)
      .then((res) => {
        _this.list = res.data;
      })
      .catch((err) => {
        console.log(err);
      });
  },
};
</script>
<style scoped>
.scanList {
  margin: 10px;
  border: 1px solid #eee;
  border-radius: 5px;
  font-size: 14px;
  padding: 8px;
}

.listBottomLine {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 0;
}
.listBottomLine p:last-child {
  width: 100px;
  flex-shrink: 0;
  margin-right: 10px;
}
.listBottomLine p:last-child {
  color: #666666;
  text-align: right;
}
.listBottomLine div {
  color: #e62129;
  text-decoration: underline;
  margin: 0 auto;
}
.detailList {
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 0 5px 0 #eee;
  border: 1px solid #eee;
  font-size: 14px;
  padding: 6px 4px;
  margin: 4px;
}
</style>
